"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockStatus = void 0;
var domain_1 = require("@genoa/domain");
exports.mockStatus = {
    bill_transaction_id: 'A129c2c11d97c73256c9ccd690d7fe3fb25',
    stage: domain_1.BillStage.GET_READY,
    bill_paid_date: null,
    bp_start_date: '2024-11-05',
    bp_end_date: '2024-12-05',
    show_next_month_date: '2024-11-27',
    estimation_amount: 200000,
    actual_amount: 362583,
    amount_status: 'CONFIRMED',
    account_status: 'ACTIVE',
    bill_status: 'SCHEDULED',
    service_issue_code: null,
    service_issue_description: 'Flex is scheduled to pay your rent bill',
    membership_fee_period: 'P1M',
    membership_fee_amount: 1499,
    repayment_period: null,
    payments: [
        {
            payment_status: 'SCHEDULED',
            failure_reason: null,
            next_auth_attempt: null,
            next_payment_retry_window: null,
            amount: 302823,
            base_amount: 292583,
            processing_fee: 10240,
            processing_fee_percent: 3.5,
            outstanding_balance: 302823,
            bill_date: '2024-12-01',
            property_passthrough_fee_amount: null,
            payment_category: '1ST_PAYMENT',
            user_payment_public_id: '',
            can_pre_fund: false,
            can_pay_now: null,
            can_reschedule: null,
            payment_transaction_id: null,
            is_security_deposit: null,
            is_additional_security_deposit: null,
        },
        {
            payment_status: 'SCHEDULED',
            failure_reason: null,
            next_auth_attempt: null,
            next_payment_retry_window: null,
            amount: 72450,
            base_amount: 70000,
            processing_fee: 2450,
            processing_fee_percent: 3.5,
            outstanding_balance: 72450,
            bill_date: '2024-12-15',
            property_passthrough_fee_amount: null,
            payment_category: '2ND_PAYMENT',
            user_payment_public_id: '',
            can_pre_fund: false,
            can_pay_now: null,
            can_reschedule: null,
            payment_transaction_id: null,
            is_security_deposit: null,
            is_additional_security_deposit: null,
        },
        {
            payment_status: 'SCHEDULED',
            failure_reason: null,
            next_auth_attempt: null,
            next_payment_retry_window: null,
            amount: 1499,
            base_amount: null,
            processing_fee: null,
            processing_fee_percent: null,
            outstanding_balance: 1499,
            bill_date: '2024-12-15',
            property_passthrough_fee_amount: null,
            payment_category: 'MEMBERSHIP_FEE',
            user_payment_public_id: '',
            can_pre_fund: false,
            can_pay_now: null,
            can_reschedule: null,
            payment_transaction_id: null,
            is_security_deposit: null,
            is_additional_security_deposit: null,
        },
    ],
    biller_type: 'DIRECT_INTEGRATION',
    out_of_network: null,
    flex_anywhere: null,
};
